module.exports = __webpack_public_path__ + "img/duke.ae8c9f09.png";